let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j0lPw")).then(() => parcelRequire('ajonx'));